const trTR = {
  brand: "URLCADE",
  defaultNickname: "Oyuncu",
  tagline: "Sayfalar oyuna dönüşüyor.",
  heroTitle: "Sayfanı seç,\narkadaşlarını çağır,\noyuna gir.",
  heroDescription:
    "Scroll Rush rotasında yarış, arkadaşlarınla saklan, logoyu kap, sayfa arenasında kapış ya da tarayıcı patronunu birlikte yen.",
  localPlay: "Tek başıma oyna",
  createRoom: "Oda kur",
  joinRoom: "Koda katıl",
  localLabel: "YEREL PARKUR",
  rushLabel: "SCROLL RUSH",
  hideLabel: "SİTE SAKLAMBAÇI",
  hideDescription: "2–4 kişi. Bir ebe. Sayfanın içinde saklanan oyuncular.",
  rushDescription: "Kontrol noktalarını geç, düşüşünü toparla, hedefe ulaş.",
  captureLabel: "LOGO KAPMACA",
  captureDescription: "İki kişilik takımlarla logoyu kap, rakipleri savuştur, kendi alanına taşı.",
  brawlLabel: "SAYFA ARENASI",
  brawlDescription: "Altı kişiye kadar. Rakipleri arenadan it, kırılan siperlerin arasından yol bul.",
  bossLabel: "TARAYICI PATRONU",
  bossDescription: "Birlikte üç anahtarı etkinleştir, zayıf nokta açılınca saldır.",
  challengeTitle: "Meydan okuma",
  challengeDescription: "Önceden hazırlanmış bir Scroll Rush rotası paylaş; süre, harita ve hareket sürümü eşleşsin.",
  challengeCreate: "Meydan okuma kur",
  challengeOptionMissing: "Bu haritada paylaşılabilir bir Rush rotası bulunmuyor.",
  challengeIntegrityHint: "Meydan okuma oluşturmadan önce harita görselleri ve SHA-256 özetleri denetlenmeli.",
  challengeServerRecordOnly: "Süre ve hayalet kaydı yalnızca tamamlanan yetkili sunucu koşusundan oluşturulur; istemci kayıt yükleyemez.",
  challengeTitleValidation: "Meydan okuma adı 2–60 karakter olmalı.",
  challengeMapUnavailable: "Bu meydan okumanın haritası bu sürümün paket kataloğunda yok.",
  challengeLeaderboardUnavailable: "Sunucu sıralaması şu anda açılamıyor.",
  challengeGhostHint: "Yalnızca bu meydan okumaya ait, sunucunun kaydettiği koşular hayalet olarak gösterilir.",
  challengeMap: "Harita özeti",
  serverRecords: "SUNUCU KAYITLARI",
  ghostActive: "Hayaleti gizle",
  ghostLabel: "Hayalet koşu",
  challengeRoomDescription: "Bu davet özel bir Rush odası açar. Sonuç, sunucu meydan okuma kaydıyla eşleştiğinde sıralamaya eklenir.",
  verifyMap: "Haritayı doğrula",
  playerLimitHint: "Odayı başlatmak için {min}–{max} oyuncu gerekir.",
  mapLabel: "Harita",
  hideInputHelp: "Hareket: A/D veya ←/→ · Zıpla: Space · E: görünüm seç · F: dönüşüm · Dokun: tara",
  captureInputHelp: "Hareket: A/D · Zıpla: Space · Atıl: Shift · Q: it · E: logoyu al veya bırak",
  brawlInputHelp: "Hareket: A/D · Zıpla: Space · Q: it · R: alan darbesi",
  bossInputHelp: "Hareket: A/D · Zıpla: Space · E: anahtar, zayıf noktada basılı tut",
  interactShort: "E tut",
  captureTeam: "Takımın",
  pushNoTarget: "İtilecek yakın bir rakip yok.",
  bossNoTarget: "Yakında etkinleştirilecek anahtar veya erişilebilir zayıf nokta yok.",
  challengeOpen: "Meydan okumayı aç",
  challengeOption: "Hazır rota",
  challengeName: "Meydan okuma adı",
  challengeNamePlaceholder: "Örn. Gece rotası",
  challengeShare: "Bağlantıyı paylaş",
  challengeLeaderboard: "En iyi kayıtlı koşular",
  challengeGhost: "Hayalet koşuyu göster",
  challengeNoRecords: "Bu meydan okumada henüz sunucuda kaydedilmiş koşu yok.",
  challengeRequiresOnline: "Meydan okuma kurmak ve sunucu kaydını görmek için çevrimiçi servisler gerekir.",
  challengeVersionUnavailable: "Bu meydan okuma başka bir harita veya hareket sürümüne bağlı; bu istemciyle oynatılamaz.",
  challengeCreated: "Meydan okuma kuruldu. Bağlantıyı arkadaşlarınla paylaş.",
  challengeLoading: "Meydan okuma sunucudan yükleniyor…",
  challengeCreationFailed: "Meydan okuma sunucuda kurulamadı.",
  challengeStart: "Bu rotada oyna",
  challengeShareCopied: "Meydan okuma bağlantısı kopyalandı.",
  challengeCopiedFallback: "Bağlantı kopyalanamadı; adres çubuğundaki bağlantıyı paylaş.",
  challengeError: "Meydan okuma açılamadı.",
  challengeHostOnly: "Meydan okuma rotasını lobi kurucusu seçer.",
  ghostReplayLoading: "Sunucu hayalet koşusu yükleniyor…",
  ghostReplayUnavailable: "Bu meydan okumada gösterilecek sürüm uyumlu bir kayıt yok.",
  ghostReplayVersion: "Hayalet yalnız aynı harita ve hareket sürümünde gösterilir.",
  multiplayerOnly: "Bu modlar yetkili çevrimiçi oda gerektirir; servis yapılandırılmadan oynatılamaz.",
  practiceStart: "Tek başına dene",
  practiceStarting: "Hazırlanıyor…",
  practiceUnranked: "ÖZEL ANTRENMAN · DERECESİZ",
  practiceVerifyingMap: "Harita özeti ve sürümü doğrulanıyor…",
  practiceConnecting: "Güvenli antrenman odası açılıyor…",
  practicePreparing: "Harita hazırlanıyor…",
  practicePrivacy: "Gerçek oturumunla tek kişilik sunucu odasına girersin. Bu antrenman sıralama, meydan okuma kaydı veya hayalet oluşturmaz.",
  practiceLobby: "Tek kişilik antrenman. Sonuçlar kaydedilmez ve sıralamaya girmez.",
  practiceResult: "Antrenman tamamlandı. Skor veya derece kaydedilmedi.",
  practiceHider: "Saklanan rolünü dene",
  practiceSeeker: "Arayan rolünü dene",
  practiceRoleLabel: "Antrenman rolü",
  practiceDummy: "Antrenman kuklası",
  captureObjective: "Logoyu rakip alandan kendi alanına 3 kez taşı.",
  logoCenter: "Logo merkezde",
  logoCarried: "Logo taşınıyor",
  logoDropped: "Logo yerde",
  logoYouCarry: "Logoyu sen taşıyorsun",
  logoCarrier: "{name} logoyu taşıyor",
  logoReturnsIn: "Merkeze dönmesine {seconds} sn",
  logoTooFar: "Logoyu almak için yanına yaklaş.",
  redTeam: "Kırmızı takım",
  blueTeam: "Mavi takım",
  pushAction: "İt",
  pushHint: "Yakındaki rakibi it",
  actionCooldown: "İtme beklemesi",
  spawnProtected: "Doğma koruması",
  stunned: "Sersemledin",
  captureScore: "Teslimat",
  brawlObjective: "3 dakikada rakipleri arenadan düşür; eşit skor ortak derece.",
  areaBurst: "Alan darbesi",
  burstCooldown: "Alan darbesi beklemesi",
  fallPoints: "Düşürme puanı",
  breakableRebuild: "Siper yeniden kuruluyor",
  bossObjective: "Anahtarları etkinleştir; 8 saniyelik açıklıkta zayıf noktaya ulaş.",
  bossSwitches: "Etkin anahtarlar",
  bossWeakWindow: "Zayıf nokta açık",
  bossCycles: "Başarılı döngü",
  bossProgress: "Ortak ilerleme",
  bossRescues: "Kalan kurtarma hakkı",
  bossTelegraph: "Saldırı alanı işaretlendi",
  interact: "Etkileşim",
  capturePlayerCount: "2'ye 2 · 4 oyuncu",
  brawlPlayerCount: "2–6 oyuncu",
  bossPlayerCount: "1–4 oyuncu · işbirliği",
  challengePlayerCount: "1–4 oyuncu · meydan okuma",
  redTeamWon: "Kırmızı takım kazandı.",
  blueTeamWon: "Mavi takım kazandı.",
  matchDraw: "Maç berabere tamamlandı.",
  bossVictory: "Patron yenildi. Takım üç döngüyü tamamladı.",
  bossDefeat: "Patron karşılaşması tamamlanmadı.",
  modeSelect: "Mod seç",
  modeOnlineRequired: "Çevrimiçi oda gerekir",
  hashMismatch: "Bu meydan okuma sunucuda farklı bir harita özetiyle kayıtlı.",
  homeNav: "Ana sayfa",
  howNav: "Nasıl oynanır",
  settings: "Ayarlar",
  settingsTitle: "Oyun ayarları",
  sound: "Ses efektleri",
  reducedMotion: "Azaltılmış hareket",
  visualQuality: "Görüntü kalitesi",
  visualQualityHelp: "Tuval çözünürlüğü ve görsel parçacık yoğunluğu değişir; oyun fiziği ve çevrimiçi kurallar aynı kalır.",
  qualityEconomy: "Ekonomi · daha düşük çözünürlük",
  qualityBalanced: "Dengeli",
  qualityHigh: "Yüksek · daha keskin görüntü",
  nickname: "Takma ad",
  nicknameHint: "2–18 karakter · sadece bu maçta görünür",
  roomCode: "Oda kodu",
  roomCodeHint: "Arkadaşının paylaştığı 8 karakterli kod",
  continue: "Devam et",
  cancel: "Vazgeç",
  close: "Kapat",
  chooseMap: "Sayfanı seç",
  chooseMapDescription: "Bu haritalar oyun için hazırlanmış, özgün sayfa kopyalarıdır.",
  loadingMaps: "Haritalar yükleniyor…",
  noMaps: "Henüz yerel harita paketi yok.",
  noMapsDescription: "Harita paketleri eklendiğinde burada görünecek. Çevrimiçi oda da harita olmadan başlatılamaz.",
  loadFailed: "Harita listesi açılamadı.",
  retry: "Yeniden dene",
  localBest: "Bu cihazdaki en iyi",
  noLocalBest: "Henüz süre yok",
  localRushOnDevice: "Bu sürümü cihazda oyna",
  showBestGhost: "En iyi koşuyu göster",
  hideBestGhost: "En iyi koşuyu gizle",
  bestGhostLoading: "En iyi koşu yükleniyor…",
  bestGhostMissing: "Bu sürüm için kayıtlı koşun yok.",
  startLocal: "Parkura başla",
  multiplayerUnavailable: "Çevrimiçi oyun şu anda yapılandırılmamış.",
  missingServices: "Oda kurmak için oyun sunucusu ve Supabase anonim oturumu gerekir. Ayarlar yapılandırıldığında çevrimiçi oyun açılır.",
  createTitle: "Arkadaşlarını çağır",
  joinTitle: "Oda kodunu gir",
  createDescription: "Özel bir oda kur. Kod yalnız davet ettiğin kişilerle paylaşılır.",
  joinDescription: "Arkadaşının oda kodunu veya davet bağlantısını kullan.",
  lobbyTitle: "Oda lobisi",
  lobbyWaiting: "Oyuncular bekleniyor",
  mapLoading: "Harita varlıkları yükleniyor",
  ready: "Hazırım",
  notReady: "Hazır değilim",
  startGame: "Oyunu başlat",
  copyInvite: "Davet bağlantısını kopyala",
  copied: "Davet bağlantısı kopyalandı",
  room: "Oda",
  host: "Kurucu",
  loadingAsset: "Harita yükleniyor",
  mapVersion: "Harita sürümü",
  versionMismatch: "İstemci ve oda sürümü uyuşmuyor. Sayfayı yenileyip tekrar katıl.",
  assetMismatch: "Bu odanın harita sürümü yüklenemedi. Başka sürümle devam etmek güvenli değil.",
  multiplayerError: "Odaya bağlanırken sorun oluştu.",
  matchDisconnected: "Bağlantı kesildi. Oda yeniden bağlanmayı bekliyor.",
  resumeRoom: "Odaya yeniden bağlan",
  leaveRoom: "Lobiden ayrıl",
  rematch: "Rövanş iste",
  backHome: "Ana sayfaya dön",
  backToModeSelection: "Mod seçimine dön",
  results: "Maç sonucu",
  matchHistory: "Son maçlar",
  noHistory: "Bu cihazda henüz yerel parkur sonucu yok.",
  privacyNote: "Yerel sürelerin yalnız bu tarayıcıda saklanır; çevrimiçi rekor olarak paylaşılmaz.",
  yourTime: "Bu cihazdaki süren",
  dnf: "Bitiş tamamlanmadı",
  penalty: "Düşüş cezası",
  checkpoints: "Kontrol noktaları",
  pause: "Duraklat",
  resume: "Devam et",
  jump: "Zıpla",
  dash: "Atıl",
  scan: "Tara",
  transform: "Dönüş",
  selectProp: "Yakındaki görünümü seç",
  caught: "Yakalandın. Tur bitene kadar bekle.",
  hidden: "Kılık değiştirildi",
  hider: "Saklanan",
  seeker: "Arayan",
  energy: "Tarama enerjisi",
  searchTime: "Arama süresi",
  hint: "Yaklaşık bölge ipucu",
  portraitMode: "Daha rahat oynamak için cihazını yatay çevir.",
  inputHelp: "Hareket: A/D veya ←/→ · Zıpla: Space · Atıl: Shift",
  networkConnecting: "Sunucuya bağlanıyor…",
  authConnecting: "Anonim oturum hazırlanıyor…",
  roomCreated: "Özel oda kuruldu.",
  roomJoined: "Odaya katıldın.",
  roomFull: "Bu oda dolu.",
  invalidNickname: "Takma ad 2–18 karakter arasında olmalı.",
  invalidRoomCode: "Oda kodu 8 harf veya sayıdan oluşmalı.",
  copyFailed: "Bağlantı otomatik kopyalanamadı. Davet bağlantısı alanını seçip kopyalayabilirsin.",
  closeDialog: "Pencereyi kapat",
  historyTitle: "Bu cihazdaki dereceler",
  historyClear: "Geçmişi temizle",
  historyClearConfirm: "Bu tarayıcıdaki yerel parkur süreleri silinsin mi?",
  historyCleared: "Yerel süreler temizlendi.",
  soundMute: "Ses efektlerini sessize al",
  soundEnable: "Ses efektlerini aç",
  browserWithFriends: "Tarayıcıda, arkadaşlarınla",
  privateInviteHint: "Özel odalar davet bağlantısıyla açılır; rastgele URL tarama yok.",
  localMapLabel: "yerel harita · oyun kopyası",
  heroArtworkLabel: "URLCADE · OYUN ALANI",
  checkpointProgress: "kontrol noktası · 02/03",
  routeToFinish: "bitişe giden yol",
  firstTwoModes: "Oyun alanları",
  twoGames: "Sayfadan doğan beş oyun.",
  modesDescription: "Her mod, aynı hazırlanmış haritayı başka bir mücadeleye çevirir. Yalnız oynanan parkur ve özel çevrimiçi odalar ayrıdır.",
  goToCourse: "Parkura git",
  roomSetup: "Oda kur",
  mapDigestLoading: "Görsel dosyaları ve özetleri kontrol ediliyor…",
  privateRoom: "Özel davetli oda",
  inviteLink: "Davet bağlantısı",
  exampleNickname: "Örn. MaviKedi",
  nicknameInputHint: "2–24 karakter · harf, sayı ve temel noktalama",
  gameMode: "Oyun modu",
  hideNeedsFour: "Başlamak için odada 2–4 oyuncu gerekir.",
  rushPlayerCount: "2–4 oyuncu, özel oda.",
  noMapForMode: "Seçilen mod için paketlenmiş harita yok.",
  mapsReady: "harita",
  multiplayerCreateDisabled: "Servis hazır olana kadar çevrimiçi oda açılmaz.",
  multiplayerJoinDisabled: "Servis hazır olana kadar odaya katılma kapalı.",
  noMapOption: "Uygun harita yok",
  roomPlayers: "Oyuncular",
  connected: "Bağlı",
  waitingConnection: "Bağlantı bekleniyor",
  waiting: "Bekliyor",
  loadedReady: "Harita ve tüm görseller yüklendi. Hazır olduğunda katıl.",
  assetsNeedChecking: "Varlıklar denetlenmeden hazır olamazsın.",
  mapVersionPinned: "Harita sürümü sabitlenir; herkes aynı dosyaları yükleyince hazır olabilir.",
  hideNeedsFourHelp: "Saklambaç 2–4 kişiyle oynanır: bir ebe, kalan oyuncular saklanan olur.",
  rushNeedsTwoHelp: "Parkur için en az iki oyuncu gerekir.",
  rushChallengeSoloLobby: "Bu meydan okuma tek oyuncuyla başlatılabilir.",
  mapPreparing: "Harita hazırlanıyor…",
  mapMustLoad: "Önce harita yüklensin",
  playArea: "Oyun alanı",
  founder: "Kurucu",
  seekerWon: "Arayan kazandı",
  hidersWon: "Saklananlar kazandı",
  roundComplete: "tur tamamlandı",
  nextRoundRoles: "Yeni tur başlarken roller sunucudan güncellenecek.",
  caughtWait: "Sahne diğer oyuncuları izlemeye geçmez. Tur sonucu gelene kadar burada bekle.",
  exitGame: "Oyundan çık",
  movementControls: "Hareket kontrolleri",
  moveLeft: "Sola git",
  moveRight: "Sağa git",
  playerCount: "oyuncu",
  courseComplete: "Parkur tamamlandı.",
  localOnlyResult: "Bu süre yalnızca bu cihazda saklanır.",
  timeExpired: "Süre doldu; yeniden denemek istersen parkura dönebilirsin.",
  localCourseResult: "Yerel parkur sonucu",
  playAgain: "Yeniden oyna",
  resultSaved: "Sonuç sunucuya kaydedildi.",
  resultSaving: "Sunucu sonucu kaydediyor…",
  resultUnconfigured: "Kalıcılık servisi yapılandırılmamış; bu sonuç kalıcı kayda alınmadı.",
  resultFailed: "Sonuç kaydedilemedi. Bu ekran sunucunun belleğindeki sonucu gösteriyor.",
  privateRoomShort: "Özel oda",
  personalPreferences: "Kişisel tercihler",
  localSettings: "Bu ayarlar yalnız bu tarayıcıda saklanır.",
  localSoundsDescription: "İlk dokunuştan sonra kısa, yerel arayüz sesleri çalar.",
  reducedMotionDescription: "Hareketli süsleri azaltır; oyun fiziğini değiştirmez.",
  anonymousSessionNote: "Çevrimiçi oyun Supabase anonim oturumu kullanır. Tarayıcı verilerini temizlersen anonim kimliğin kaybolabilir.",
  localAndOnline: "Yerel ve çevrimiçi",
  historyDescription: "Yerel parkur süreleri ve bu anonim oturumun sunucuya kaydedilen maçları.",
  localCourses: "Bu cihazdaki parkurlar",
  onlineMatches: "Sunucuya kaydedilenler",
  onlineResult: "sunucu sonucu",
  scoreAndPenalty: "puan · ceza",
  roundCompleted: "Tur tamamlandı",
  phaseCountdown: "Başlıyor",
  phaseHiding: "Saklanma",
  phaseSearching: "Arama",
  phaseRacing: "Yarış",
  phaseRoundResult: "Tur sonucu",
  phasePaused: "Duraklatıldı",
  phasePlaying: "Oyun sürüyor",
  nicknameValidation: "Takma ad 2–24 karakter arasında olmalı.",
  roomCodeValidation: "Oda kodu 8 harf veya sayıdan oluşmalı.",
  roomModeInvalid: "Oyun modu geçersiz.",
  mapSelectionInvalid: "Bu mod için geçerli bir harita seç.",
  mapForRushOnly: "Bu harita parkur modu için değil.",
  sceneNeedsLoadedMap: "Oyun sahnesi açılmadan önce harita yüklenmeli.",
  roomMapMissingFromCatalog: "Oda haritası bu istemcinin kataloğunda yok. İstemci ve sunucu aynı map katalog sürümünü kullanmalı.",
  connectionRestored: "Bağlantı geri geldi; aynı koltukla devam ediyorsun.",
  reconnectSeatUnavailable: "Oda bu bağlantıyı sürdüremedi. Bir oyuncu yeni koltukla maça giremez.",
  temporaryHint: "Yaklaşık bölgede sinyal var. İpucu süreli.",
  hintSignal: "Yaklaşık bölgede sinyal var.",
  rematchRequested: "Rövanş isteği gönderildi. Yeni maç için oyuncular yeniden hazır olmalı.",
  historyLoadFailed: "Maç geçmişi açılamadı.",
  mapLoadFailed: "Harita yüklenemedi.",
  assetDigestError: "Harita görseli beklenen SHA-256 özetiyle eşleşmiyor. Güvenli şekilde devam edilemedi.",
  assetMissingError: "Harita görseli bulunamadı. Bu sürüm eksik varlıkla başlatılmayacak.",
  assetTooLargeError: "Harita paketi 8 MB sınırını aşıyor.",
  assetInvalidError: "Harita görseli tarayıcıda açılamadı.",
  cryptoRequiredError: "Harita varlıklarını doğrulamak için tarayıcıda Web Crypto etkin olmalı.",
  roomConnectionError: "Oda bağlantısında sorun oluştu.",
  reconnectAttempt: "Bağlantı kesildi. Yeniden bağlanmayı deniyoruz.",
  points: "puan",
  rankPlace: "sıra",
  historyLoading: "Sunucu geçmişi yükleniyor…",
  noOnlineHistory: "Bu anonim oturumda kayıtlı maç bulunmuyor.",
  hidePlayerCount: "2–4 kişi",
  racePlayerCount: "1 kişilik çevrimiçi koşu · 2–8 kişilik yarış",
  scrollRushMaps: "Scroll Rush haritaları",
  mapDigestReady: "Harita dosyaları denetleniyor…",
  catalogFormatInvalid: "Katalog biçimi okunamadı.",
  catalogEntryInvalid: "Katalogda geçersiz bir harita kaydı var.",
  catalogDuplicate: "Katalogda yinelenen harita sürümü var.",
  catalogPathInvalid: "Katalog haritayı beklenen paket yolunda göstermiyor.",
  catalogUrlInvalid: "Katalogdaki harita adresi geçersiz.",
  cryptoNeeded: "Güvenli harita özeti için Web Crypto gerekir.",
  mapFileUnavailable: "Harita dosyasına erişilemedi.",
  imageUnavailable: "Harita görseline erişilemedi.",
  mapFileTooLarge: "Harita dosyası izin verilen boyutu aşıyor.",
  mapPackageTooLarge: "Harita paketi 8 MB sınırını aşıyor.",
  mapImageInvalid: "Harita görseli açılamadı.",
  mapAddressInvalid: "Harita adresi geçersiz.",
  mapJsonInvalid: "Harita dosyası geçerli JSON değil.",
  mapContractInvalid: "Harita dosyası sözleşmeye uymuyor.",
  mapCatalogMismatch: "Harita kimliği ve sürümü katalogla uyuşmuyor.",
  mapVersionIncompatible: "Bu harita sürümü bu istemciyle uyumlu değil.",
  mapDigestMismatch: "Harita içerik özeti eşleşmiyor.",
  mapAssetEscaped: "Harita varlığı kendi paketinin dışına çıkıyor.",
  localMapMissing: "Seçilen harita katalogda yok.",
  courseModeMismatch: "Bu harita parkur modu için değil.",
  sceneNeedsMap: "Oyun sahnesi açılmadan önce harita yüklenmeli.",
  roomMapCatalogMismatch: "Oda haritası bu istemcinin kataloğunda yok. İstemci ve sunucu aynı harita katalog sürümünü kullanmalı.",
  gameReadyAnnouncement: "Oyun alanı hazır.",
  avatarSelf: "Sen",
  finishLabel: "BİTİŞ",
  nearPropHelp: "Bir sayfa öğesine yaklaş; E yakındaki görünümü seçer.",
  noNearbyScanTarget: "Yakınında taranabilecek bir hedef yok.",
  hideActionWaiting: "Oyun durumu yükleniyor; birazdan yeniden dene.",
  hideHiderOnly: "E ve F yalnızca Saklanan rolünde kullanılabilir.",
  hideSeekerOnly: "Tarama yalnızca Arayan rolünde kullanılabilir.",
  hideHiderPhase: "E ve F Saklanma veya Arama aşamasında kullanılabilir.",
  hideScanPhase: "Tarama yalnızca Arama aşamasında kullanılabilir.",
  hideChooseProp: "Önce bir sayfa öğesine yaklaş ve E ile görünüm seç.",
  hideLandToTransform: "F ile dönüşmek için önce yere in.",
  hideStopToTransform: "F ile dönüşmek için hareketi bırak.",
  hideTransformCooldown: "Dönüşüm için {seconds} sn daha bekle.",
  hideBreakDisguise: "F ile normal karakter görünümüne dön.",
  hideTransformReady: "Seçili görünümle dönüşmek için F'ye bas.",
  hideScanCooldown: "Yeni tarama için {seconds} sn bekle.",
  hideScanEnergy: "Tarama enerjin yenilenene kadar bekle.",
  hideScanGuidance: "Yakındaki alanı Tarama ile kontrol et.",
  unsupportedRoomError: "Oda bağlantısında sorun oluştu.",
  reconnectFailed: "Odaya yeniden bağlanılamadı.",
  gameNotConfigured: "Çevrimiçi oyun yapılandırılmamış.",
  authReadFailed: "Anonim oturum okunamadı.",
  authCreateFailed: "Anonim oturum açılamadı. Sunucu ayarlarını kontrol et.",
  serverNotConfigured: "Oyun sunucusu yapılandırılmamış.",
  roomActionFailed: "Oda işlemi tamamlanamadı.",
  roomResponseInvalid: "Sunucu geçerli bir oda yanıtı vermedi.",
  resultShapeInvalid: "Maç geçmişi biçimi okunamadı.",
  nicknameFormatInvalid: "Takma ad 2–24 karakter olmalı; harf, sayı, boşluk, nokta, tire ve alt çizgi kullan.",
  roomCodeFormatInvalid: "Oda kodu 8 harf veya sayıdan oluşmalı.",
  errorForbidden: "Bu işlem şu an yapılamıyor.",
  gameActionUnavailable: "Oyun durumu değişmiş olabilir. Ekrandaki yönlendirmeyi izleyip yeniden dene.",
  errorNotReady: "Tüm oyuncular hazır olmalı ve harita yüklenmeli.",
  errorRoomFull: "Bu oda dolu.",
  errorRoomMissing: "Bu oda bulunamadı.",
  errorRoomActive: "Bu maç başlamış; odaya katılınamıyor.",
  errorRateLimited: "Çok fazla istek gönderildi. Biraz bekleyip tekrar dene.",
  errorVersionMismatch: "Oda ve harita sürümleri uyuşmuyor.",
  errorAuth: "Anonim oturum doğrulanamadı. Yeniden bağlanmayı dene.",
  errorMatchAborted: "Bağlantı kurulamadığı için maç durduruldu.",
  errorGeneric: "İstek tamamlanamadı.",
  homeEyebrow: "URL'ni oyun alanına dönüştür",
  urlInputLabel: "Oynamak istediğin sayfanın adresi",
  urlInputHelp: "Tam sayfa bağlantısını yapıştır; adres HTTPS ile normalize edilir ve sunucuda kontrol edilir.",
  convertThisPage: "Bu sayfayı oyuna dönüştür",
  conversionSubmitting: "İstek gönderiliyor…",
  urlPrivacyNote: "Tarayıcı oturumun ve çerezlerin kullanılmaz. Harita varsayılan olarak özeldir.",
  conversionTitle: "Sayfan hazırlanıyor",
  conversionPrivateNotice: "Bu dönüşüm isteğini yalnız sen görebilirsin. Kaynak URL gizli kalır.",
  conversionNoSourceLeak: "Gizliliğin için tam adres burada gösterilmez.",
  conversionLoading: "İş durumu sunucudan alınıyor…",
  conversionProgress: "Tamamlanan aşama",
  conversionLoadFailed: "Dönüşüm isteği yüklenemedi.",
  conversionReadyCopy: "Sayfa kopyası ve uygun modlar hazır.",
  openGameCopy: "Harita önizlemesini aç",
  cancelConversion: "İşi iptal et",
  retryConversion: "Yeniden dene",
  refreshStatus: "Durumu yenile",
  phaseQueued: "Sırada",
  phasePolicyCheck: "Güvenlik ve erişim kontrolü",
  phaseCapturing: "Sayfa görüntüleniyor",
  phaseExtracting: "Sayfa geometrisi çıkarılıyor",
  phaseCompiling: "Oyun modları hazırlanıyor",
  phasePackaging: "Harita dosyaları paketleniyor",
  phaseReady: "Harita hazır",
  phaseRejected: "Bu adres şu anda işlenemiyor",
  phaseFailed: "İş tamamlanamadı",
  phaseCancelled: "İş iptal edildi",
  phaseExpired: "İstek süresi doldu",
  urlInvalid: "Geçerli bir sayfa adresi gir.",
  urlSchemeUnsupported: "Yalnız HTTP veya HTTPS sayfaları işlenebilir.",
  urlTargetBlocked: "Bu adres güvenli erişim kurallarına uymuyor.",
  urlSecretBlocked: "Adres gizli bir imza veya erişim anahtarı içeriyor. Gizli olmayan sayfa adresini kullan.",
  urlPolicyBlocked: "Bu kaynak ürün erişim ilkeleri nedeniyle işlenemiyor.",
  urlAuthRequired: "Kaynak sayfa oturum açma gerektiriyor; URLcade kullanıcı çerezi veya parolası almaz.",
  urlChallengeBlocked: "Kaynak CAPTCHA veya bot doğrulaması istiyor; bu kontrol aşılmaz.",
  urlContentUnsupported: "Sayfa türü yakalama için desteklenmiyor.",
  urlCaptureTimeout: "Sayfanın yakalanması zaman sınırını aştı.",
  urlCaptureLimit: "Sayfa yakalama kaynak sınırını aştı.",
  urlCaptureUnstable: "Sayfa kararlı bir kopya oluşturacak kadar yüklenmedi.",
  urlNoModes: "Bu sayfada oynanabilir bir mod bulunamadı. Başka bir bölüm veya URL seçebilirsin.",
  urlQuota: "Yakalama kotası doldu. Daha sonra yeniden deneyebilirsin.",
  urlQueueFull: "Yakalama kuyruğu şu anda dolu. İstek gönderilmedi; biraz sonra yeniden dene.",
  captureNotConfigured: "Sayfa yakalama hizmeti şu anda yapılandırılmamış. Sunucu demo sonucu üretmez.",
  accessRevoked: "Bu içeriğe erişim kaldırılmış veya süresi dolmuş.",
  sourceRemoved: "Kaynak, sahibinin isteğiyle kaldırılmış.",
  statusPending: "Sonuç kaydı beklemede.",
  conversionGenericError: "İşlem tamamlanamadı. Durumu yenileyip tekrar deneyebilirsin.",
  mapDetails: "Sayfa kopyası",
  authorizedMapLoading: "Haritanın erişim izni denetleniyor…",
  mapUnavailable: "Bu haritaya erişilemiyor veya sürümü kaldırılmış.",
  capturedAt: "Yakalama zamanı",
  snapshotImmutable: "Bu oyun kopyası değişmez bir sürümdür.",
  authorizedPreviewPending: "Özel önizleme güvenli dosya izniyle yüklenir.",
  availableModesLoading: "Uygun modlar yükleniyor…",
  saveToLibrary: "Kütüphaneme kaydet",
  savedToLibrary: "Harita kütüphanene kaydedildi.",
  recapturePage: "Sayfayı yeniden yakala",
  privateMapAssets: "Özel görseller yalnız yetkili dosya erişimiyle yüklenir; herkese açık önbelleğe alınmaz.",
  mapVisibility: "Görünürlük",
  sourcePage: "Kaynak sayfa",
  sourceSectionSelected: "Oyun alanı için sayfanın ilk uygun {height} piksellik bölümü kullanıldı.",
  noDescription: "Bu harita için ek açıklama yok.",
  mapVersions: "Harita sürümleri",
  modeSuitability: "Bu sayfada oynanabilecek modlar",
  noModes: "Sunucu henüz oynanabilir mod bildirmedi.",
  preview: "Önizle",
  suitabilitySupported: "Uygun",
  suitabilityAdapted: "Uyarlanmış",
  suitabilityUnavailable: "Uygun değil",
  suitabilityReady: "Bu sürüm için ek sınırlama bildirilmedi.",
  suitabilityReasonGeneric: "Bu mod için ek koşullar gerekiyor.",
  playerSingle: "oyuncu",
  players: "oyuncu",
  modeChooseHeading: "Bu sayfayı nasıl oynayalım?",
  modeChooseDescription: "Beş mod da bu sayfanın gerçek oyun alanına göre denetlenir. Uygun bir modu seç; oyun kopyası ve önizlemesi aynı sürümden açılır.",
  modePreviewTitle: "Seçili mod",
  selectedMapVersion: "Harita sürümü",
  mapToolsSummary: "Harita işlemleri ve geçmişi",
  mapToolsVersionHistory: "Oluşturulan sürümler",
  modeVersionUnavailable: "Bu mod için uyumlu oynanabilir sürüm hazır değil.",
  modeUnavailableHint: "Oynanabilir sürüm yok",
  modeAdaptedFallback: "Kaynak sayfa, bu modun oyun kurallarına uyacak şekilde düzenlendi.",
  modeNativeFallback: "Kaynak sayfanın görünümü korundu; ek oyun katmanı kullanılmadı.",
  reason_SOURCE_ROUTE_SUPPORTED: "Parkur boşluklarını bağlamak için sınırlı destek platformları eklendi.",
  reason_SOURCE_PROP_VARIETY_ADAPTED: "Saklanma modu için farklı prop görünümleri eklendi.",
  reason_CAPTURE_OBJECTIVES_ADAPTED: "Takımlar için ayrı hedef alanları ve oyuna ait bir hedef eklendi.",
  reason_BRAWL_COVER_ADAPTED: "Sayfa görünümü korunarak üstüne sınırlı kırılabilir oyun kapakları eklendi.",
  reason_BOSS_OBJECTIVES_ADAPTED: "Boss karşılaşması için boss görseli ve etkileşim hedefleri eklendi.",
  modeReasonRush: "Başlangıçtan hedefe ulaşan, birbirine bağlı bir parkur oluşmadı.",
  modeReasonHide: "Yeterli farklı saklanma noktası ve bunları bağlayan güvenli alan yok.",
  modeReasonCapture: "İki takım alanı, kaynak logosu ve dengeli geçiş yolları birlikte oluşmadı.",
  modeReasonBrawl: "Güvenli biçimde kırılabilen sayfa öğeleri, kalıcı zemin ve erişilebilir arena yok.",
  modeReasonBoss: "Üç anahtar bölgesi, boss görseli ve erişilebilir arena birlikte oluşmadı.",
  reason_support_platform: "Parkur boşluklarını bağlamak için destek platformları eklendi.",
  reason_creator_support: "Parkur boşluklarını bağlamak için destek platformları eklendi.",
  reason_route_gap: "Kaynak yüzeyler arasındaki boşluk güvenli desteklerle kapatıldı.",
  reason_creator_patch: "Seçilen oyun alanına özel destek yüzeyleri eklendi.",
  noPlayableMapMode: "Bu sayfada oynanabilir mod yok.",
  noPlayableMapModeDescription: "Beş modun da gerçek sayfa yüzeylerine, geçiş yollarına veya hedeflerine ihtiyacı var. Başka bir sayfa deneyip yeniden yakalayabilirsin.",
  modeOnlineUnavailable: "Çevrimiçi oda ve sunucu pratik hizmeti şu anda yapılandırılmamış; bu modda oynama başlayamaz.",
  previewLoadFailed: "Bu özel harita sürümü yüklenemedi.",
  modePreviewRetry: "Önizlemeyi yükle",
  playSoloRush: "Tek başına Scroll Rush oyna",
  reason_SUPPORT_PLATFORMS_ADDED: "Oyun rotasını bağlamak için destek platformları eklendi.",
  reason_CREATOR_SUPPORTS_ADDED: "Oyun rotasını bağlamak için destek platformları eklendi.",
  reason_RUSH_PLATFORM_DENSITY: "Bu bölümde parkur için yeterli zıplama platformu yok.",
  reason_RUSH_SPAWN_UNSUPPORTED: "Başlangıç noktası güvenli bir platforma yerleştirilemiyor.",
  reason_RUSH_ROUTE_UNREACHABLE: "Başlangıçtan hedefe kesintisiz bir parkur kurulamıyor.",
  reason_HIDE_VISIBLE_VARIETY_LOW: "Yeterli sayıda farklı ve görünür saklanma noktası bulunamadı.",
  reason_HIDE_DECOY_SURFACES_MISSING: "Saklanan oyuncular için uygun sayfa yüzeyleri bulunamadı.",
  reason_HIDE_PLAYABLE_NETWORK_UNREACHABLE: "Saklanma alanları arasında güvenli bir geçiş ağı kurulamıyor.",
  reason_HIDE_CONNECTIVITY_SEARCH_BOUNDED: "Saklanma alanlarının birbirine bağlandığı doğrulanamadı.",
  reason_DECOY_PLACEMENT_UNSUITABLE: "Görünüş değiştirme noktaları güvenli yüzeylere yerleştirilemiyor.",
  reason_CAPTURE_ARENA_REQUIREMENTS_MISSING: "İki takım alanı veya kaynak logonun görseli bulunamadı.",
  reason_ARENA_PATH_INVALID: "Arena içindeki takım yolları sayfa yüzeyleriyle doğrulanamıyor.",
  reason_CAPTURE_TEAM_ROUTE_UNREACHABLE: "Takım alanları arasında erişilebilir bir logo taşıma yolu yok.",
  reason_CAPTURE_ALTERNATE_ROUTES_MISSING: "Takımlar için dengeli alternatif geçiş yolları kurulamıyor.",
  reason_CAPTURE_CONNECTIVITY_SEARCH_BOUNDED: "Sınırlı rota aramasında dengeli alternatif yollar bulunamadı.",
  reason_ADAPTATION_BUDGET_EXCEEDED: "Bu sayfayı oynanabilir yapmak için gerekenden fazla yapay platform gerekir.",
  reason_CAPTURE_CRITICAL_PATH_TOO_COMPLEX: "İki takımın ana oyun yolları güvenle doğrulanamayacak kadar karmaşık.",
  reason_CAPTURE_ROUTE_COST_UNBALANCED: "İki takımın logoya ulaşma yolları dengeli değil.",
  reason_CAPTURE_OBJECTIVE_UNREACHABLE: "Kaynak logo iki takımın da erişebileceği bir noktaya yerleştirilemiyor.",
  reason_BRAWL_SAFE_DESTRUCTIBLES_MISSING: "Güvenle kırılabilecek gerçek sayfa öğeleri bulunamadı.",
  reason_BRAWL_SPAWN_SURFACES_MISSING: "Oyuncular için yeterli güvenli başlangıç yüzeyi yok.",
  reason_BRAWL_PERMANENT_GROUND_MISSING: "Arena için kırılmayacak kalıcı bir zemin bulunamadı.",
  reason_BRAWL_CRITICAL_PATH_UNREACHABLE: "Oyuncuların arenada dolaşabileceği doğrulanmış bir yol yok.",
  reason_BREAKABLE_INVALID: "Kırılabilir sayfa öğelerinin güvenli sınırları doğrulanamadı.",
  reason_BOSS_ARENA_REQUIREMENTS_MISSING: "Boss görseli veya oyuncu başlangıç alanları bulunamadı.",
  reason_BOSS_CRITICAL_PATH_UNREACHABLE: "Boss arenasındaki alanlara ulaşılabilir bir yol kurulamıyor.",
  reason_BOSS_SWITCH_REGIONS_MISSING: "Birbirinden ayrı üç anahtar bölgesi bulunamadı.",
  reason_BOSS_TARGET_UNREACHABLE: "Boss'un zayıf noktası oyuncuların erişebileceği bir konumda değil.",
  reason_REGION_WIDTH_UNSUPPORTED: "Bu bölümün genişliği bu mod için uygun değil.",
  reason_CAPTURE_ASSETS_MISSING: "Kaynak sayfadan arena için gerekli görseller alınamadı.",
  reason_ARTIFACT_ASSET_BUDGET_EXCEEDED: "Bu haritanın güvenli görsel dosya sınırı aşıldı.",
  reason_VISUAL_LAYER_BUDGET_EXCEEDED: "Bu sayfada güvenle kullanılabilecek görsel öğe sınırı aşıldı.",
  reason_CAPTURE_BUNDLE_INVALID: "Kaynak sayfanın oyun kopyası doğrulanamadı.",
  reason_CAPTURE_HEIGHT_LIMIT: "Bu bölüm çok uzun olduğu için tek bir parkura dönüştürülemiyor.",
  reason_MODE_LAYOUT_UNAVAILABLE: "Bu bölüm için güvenli bir oyun alanı çıkarılamadı.",
  reason_REGION_INVALID: "Seçilen sayfa bölgesi güvenli sınırlar içinde değil.",
  reason_REGION_NOT_FOUND: "Seçilen sayfa bölümü kaynak görüntüde bulunamadı.",
  reason_SPAWN_UNSUPPORTED: "Başlangıç noktası uygun bir sayfa yüzeyine yerleştirilemiyor.",
  reason_SPAWN_BLOCKED: "Başlangıç noktası sayfa öğeleri tarafından kapatılmış.",
  reason_TARGET_UNSUPPORTED: "Oyun hedefi bu sayfada güvenli bir yere yerleştirilemiyor.",
  reason_UNREACHABLE_ROUTE: "Oyun hedeflerine ulaşan bir rota bulunamadı.",
  reason_WORLD_INVALID: "Sayfanın oyun alanı sınırları doğrulanamadı.",
  reason_CRITICAL_PATH_INVALID: "Oyuncuların izlemesi gereken ana rota doğrulanamadı.",
  reason_MODE_LAYOUT_INVALID: "Bu mod için sayfa düzeni güvenli şekilde çözümlenemedi.",
  reason_NO_COLLIDERS: "Oyuncuların üzerinde ilerleyebileceği sayfa yüzeyi yok.",
  reason_NO_PROPS: "Saklanma veya arena hedefi olabilecek görünür sayfa öğesi yok.",
  reason_HIDE_PROPS: "Saklanmak için yeterli görünür sayfa öğesi bulunamadı.",
  reason_MISSING_ASSET: "Gerekli sayfa görseli oyun kopyasında yok.",
  reason_MISSING_MODE_ASSET: "Bu mod için gerekli sayfa görseli bulunamadı.",
  reason_SPAWN_OUTSIDE_WORLD: "Başlangıç noktası oyun alanının dışında kalıyor.",
  reason_COLLIDER_OUTSIDE_WORLD: "Bir sayfa yüzeyi güvenli oyun alanının dışında kalıyor.",
  reason_TILE_OUTSIDE_WORLD: "Bir sayfa görseli güvenli oyun alanının dışında kalıyor.",
  reason_ZONE_OUTSIDE_WORLD: "Bir oyun alanı bölgesi güvenli sınırların dışında kalıyor.",
  visibilityPrivate: "Özel",
  visibilityUnlisted: "Bağlantıyla erişilen",
  visibilityPublic: "Herkese açık",
  sharePrivateMap: "İzinli bağlantı oluştur",
  shareLinkCopied: "Sunucunun verdiği paylaşım bağlantısı kopyalandı.",
  requestPublication: "Yayın incelemesi iste",
  publicationPendingReview: "Yayın isteği inceleme bekliyor; harita henüz keşifte görünmüyor.",
  publicationStatusUpdated: "Yayın durumu sunucudan güncellendi.",
  reportContent: "İçeriği bildir",
  library: "Kütüphanem",
  discover: "Keşfet",
  profile: "Profil",
  allFiveModes: "Beş oyun modu",
  chooseHowToPlay: "Aynı sayfada farklı oyunlar",
  pageSnapshot: "Sayfanın oyun kopyası",
  primaryNavigation: "Ana gezinme",
  brandHomeLabel: "URLCADE ana sayfa",
  artPageTitle: "Her sekme, bir oyun alanı.",
  artNavRace: "Yarış",
  artNavHide: "Saklan",
  artNavTogether: "Birlikte",
  resumeRoomRequired: "Bu oda bağlantısı bu oturumda açık değil. Davet bağlantısından yeniden katıl.",
  shareLink: "Paylaşım bağlantısı",
  shareExpires: "Bağlantı süresi",
  copy: "Kopyala",
  revokeShare: "Bağlantıyı iptal et",
  mapPreviewDescription: "Sürümü doğrulanmış görsellerle incele. Özel varlıklar yalnızca yetkili oturumda yüklenir.",
  noMapVersion: "Bu harita sürümü kullanılamıyor.",
  loadAuthorizedPreview: "Özel önizlemeyi yükle",
  editMap: "Harita alanını düzenle",
  previewPrivateNotice: "Önizleme, yetkili dosyalar yüklenince görünür.",
  practiceUnrankedAction: "Derecesiz antrenman",
  pageSnapshotPreview: "Sayfanın oyun kopyası önizlemesi",
  creatorTools: "Harita üreticisi",
  boundedMapEditing: "Yeni sürüm için oyun alanını sınırlar içinde kırp veya mod uyarlaması oluştur.",
  creatorSetup: "Oyun yerleşimi",
  creatorPatchInvalid: "Düzenleme alanları geçerli değil. Koordinatları, sayıları ve seçilen öğeleri kontrol et.",
  spawnPoint: "Başlangıç noktası",
  checkpoint: "Kontrol noktası",
  checkpointCount: "Kontrol noktası sayısı",
  finishLine: "Bitiş alanı",
  timeLimitMs: "Süre sınırı (milisaniye)",
  seekerSpawn: "Arayan başlangıcı",
  hiderSpawn: "Saklanan başlangıcı",
  decoyCount: "Sahte iz sayısı",
  disguisePool: "Kılık seçimi",
  teamSpawnCount: "Her takımın oyuncu noktası",
  redDeliveryZone: "Kırmızı teslim alanı",
  blueDeliveryZone: "Mavi teslim alanı",
  logoSpawn: "Logo konumu",
  safeSpawn: "Güvenli başlangıç",
  breakableSelection: "Yıkılabilir nesneler",
  attackZoneCount: "Saldırı alanı sayısı",
  attackZone: "Saldırı alanı",
  weakPoint: "Zayıf nokta",
  supportPalette: "Yardımcı platform paleti",
  supportPaletteHelp: "En fazla altı platform seç. Koordinatlar yakalanmış alan ve sunucu fizik sınırlarıyla denetlenir.",
  supportPlatform: "Platform ekle",
  supportBounds: "Platform alanı",
  previewRequiresAccess: "Düzenlemeden önce haritanın özel önizlemesini yetkili oturumla yükle.",
  modeLabel: "Oyun modu",
  selectedRegion: "Oyun alanı sınırları",
  regionX: "Yatay başlangıç",
  regionY: "Dikey başlangıç",
  regionWidth: "Genişlik",
  regionHeight: "Yükseklik",
  worldBounds: "Kaynak alanı",
  regionNeedsPreview: "Alan sınırlarını görmek için özel önizlemeyi yükle.",
  creatorRegionPreviewOnly: "Bölge önizlemesi ayrı bir sürüm oluşturur; yerleşim düzenlemeleri bu adımda kaydedilmez. Önizleme hazır olunca yeni sürümü açıp düzenlemeleri orada uygula.",
  creatorRegionPreviewRequired: "Bu bölge için önce harita düzenleyicisinde yeni bir önizleme oluştur; ardından bu sürümden bir meydan okuma taslağı aç. Buradaki düzenlemeler kaydedilmedi.",
  creatorRegionFullWidth: "Tam kaynak genişliği {width} piksel olarak sabittir.",
  creatorRegionTileRangeLabel: "Tam kaynak görsel aralığı",
  creatorRegionTileRangeHelp: "Yalnızca yüklü değiştirilemez sürümde doğrulanan, tam genişlikli ve bitişik kaynak görsel aralıkları sunulur. Kesik sınırlar otomatik yuvarlanmaz.",
  creatorRegionTileRangeOption: "{start}–{end} piksel · {height} piksel yükseklik",
  creatorRegionTileRangeCurrent: "Mevcut {start}–{end} piksel aralığı güvenli bir seçim olarak kullanılamıyor.",
  creatorRegionTileRangeCurrentInvalid: "Mevcut değer korunur; önizleme için aşağıdan tam bir aralık seç.",
  creatorRegionTileRangeUnavailable: "Bu sürümde seçilebilir tam görsel sınırı doğrulanamadı. Güvenli bir aralık bulunana kadar önizleme gönderilmez.",
  creatorRegionWholeTilesRequired: "Seçilen alan, yüklü kaynak görsellerin tam sınırlarına uymuyor. Tam bir kaynak görsel aralığı seçip yeniden dene.",
  creatorCreateRegionPreview: "Yeni bölge önizlemesi oluştur",
  sourceBoundsUnavailable: "Kaynak sayfa sınırları yüklenemedi; güvenli sürüm düzenleme için harita sahibi erişimi gerekli.",
  savingVariant: "Yeni sürüm hazırlanıyor…",
  createVariant: "Yeni sürüm oluştur",
  creatorChallengeDraft: "Meydan okuma taslağı",
  creatorChallengePrivacy: "Taslak ve sürümleri varsayılan olarak özel kalır. Herkese açık yayın inceleme gerektirir.",
  description: "Açıklama",
  createCreatorDraft: "Taslağı oluştur",
  creatorDraftCreated: "Özel taslak oluşturuldu.",
  shareChallenge: "Meydan okumayı paylaş",
  libraryLoading: "Özel kütüphanen yükleniyor…",
  mapExpired: "Bu haritanın saklama süresi doldu.",
  openMap: "Haritayı aç",
  removeFavorite: "Favorilerden çıkar",
  addFavorite: "Favorilere ekle",
  privateContent: "Yalnızca sana ait içerik",
  libraryPrivacy: "Özel haritaların ve favorilerin hesabına bağlıdır; kaynak bağlantılar paylaşılmaz.",
  favoritesOnly: "Yalnızca favoriler",
  mapsCount: "harita",
  libraryEmpty: "Kütüphanen henüz boş",
  libraryEmptyHelp: "Bir sayfa adresi göndererek özel bir oyun kopyası oluşturabilirsin.",
  newUrlCapture: "Yeni sayfa yakala",
  discoverLoading: "Yayınlanmış haritalar ve açık odalar yükleniyor…",
  completedMatches: "tamamlanan maç",
  discoverPolicy: "Yalnızca onaylanmış herkese açık haritalar ve katılıma açık odalar görünür.",
  filterByMode: "Modla filtrele",
  allModes: "Tüm modlar",
  publicMaps: "Yayınlanmış haritalar",
  discoverEmpty: "Bu filtrede herkese açık harita yok.",
  loadMore: "Daha fazla yükle",
  publicRooms: "Açık odalar",
  noPublicRooms: "Şu anda katılıma açık oda yok.",
  publicOnly: "Topluluk alanı",
  profileLoading: "Profilin yükleniyor…",
  profileUnavailable: "Profil açılamadı.",
  chooseCharacter: "Karakter seç",
  profileIdentityPrivacy: "Anonim profil kimliğin hesabını yükseltirken korunur. Kaynak sayfa bağlantıların görünmez.",
  interfaceLanguage: "Arayüz dili",
  profileInputInvalid: "Takma ad, karakter veya dil seçimi geçersiz.",
  savingProfile: "Profil kaydediliyor…",
  saveProfile: "Profili kaydet",
  profileSaved: "Profilin güncellendi.",
  guestAccount: "Anonim hesap",
  permanentAccount: "Kalıcı hesap",
  upgradeAccount: "E-posta hesabına yükselt",
  upgradeAccountPrivacy: "Aynı kullanıcı kimliğini koruyarak oturumunu e-posta ve parolayla güvenceye al.",
  requestEmailLink: "Onay e-postası gönder",
  emailConfirmationInstructions: "E-posta adresini onaylayan bağlantıyı aç. Bu profilde aynı kullanıcı kimliğinle oturum açıldıktan sonra ayrı parola adımını tamamla.",
  setAccountPassword: "Parola belirle",
  accountPasswordSaved: "Parolan kaydedildi; hesabın aynı kullanıcı kimliğini kullanıyor.",
  accountEmailInvalid: "Geçerli bir e-posta adresi yaz.",
  accountPasswordInvalid: "Parolan 10–128 karakter olmalı.",
  accountEmailNotConfirmed: "Önce e-posta onay bağlantısını tamamla, sonra parola belirle.",
  accountUpgradeFailed: "Hesap güncellenemedi. Aynı oturumla yeniden dene.",
  email: "E-posta",
  password: "Parola",
  upgrading: "Hesap güncelleniyor…",
  accountIdentityPreserved: "Hesap kimliğin korunuyor.",
  accountUpgradeAccepted: "Hesap güncellemesi sağlayıcıya gönderildi. E-posta onayı gerekiyorsa durumunu gelen kutunda kontrol et.",
  deleteAccount: "Hesabı sil",
  deleteAccountAction: "Hesabımı ve özel içeriklerimi sil",
  deleteAccountWarning: "Profilin, sana ait özel haritalar, favoriler ve sunucu maç geçmişi kalıcı olarak silinir. Bu cihazdaki yerel parkur kayıtları ve ayarların korunur.",
  deleteAccountConfirm: "Hesabını ve hesaba bağlı özel içeriği kalıcı olarak silmek istiyor musun? Bu işlem geri alınamaz.",
  deletingAccount: "Hesap siliniyor…",
  accountDeleted: "Hesap ve hesaba bağlı özel içerik silindi.",
  accountDeleteFailed: "Hesap silinemedi. Oturumunu ve bağlantını kontrol edip yeniden dene.",
  admin: "Yönetim",
  adminLoading: "Yönetim özeti yükleniyor…",
  adminRestricted: "Bu alan yalnızca yetkili yöneticilere açıktır.",
  adminTools: "Güven ve operasyon",
  adminSafetyNote: "Özel kaynak URL'leri gösterilmez. Tüm değişiklikler gerekçe ile kaydedilir.",
  activeJobs: "Etkin işler",
  activeRooms: "Etkin odalar",
  capturesToday: "Bugünkü yakalamalar",
  recentJobs: "Son yakalama işleri",
  noAdminJobs: "Gösterilecek iş yok.",
  contentReports: "İçerik bildirimleri",
  noReports: "Açık bildirim yok.",
  dismissReport: "Bildirim kapat",
  takedown: "İçeriği kaldır",
  sourcePolicy: "Kaynak alan adı ilkesi",
  sourceHost: "Alan adı",
  policyAction: "İşlem",
  blockHost: "Yakalamayı engelle",
  allowHost: "Yakalamaya izin ver",
  policyReason: "Gerekçe",
  savePolicy: "İlkeyi kaydet",
  adminReasonRequired: "Gerekçe 3–500 karakter olmalı.",
  saveNewVersion: "Yeni meydan okuma sürümü oluştur",
  creatorPatchBounded: "Yeni sürüm yalnız doğrulanmış oyun alanı ve seçili moddan üretilir.",
  challengeRemoved: "Bu meydan okuma kaldırılmış veya erişimi iptal edilmiştir.",
  challengeVersion: "Meydan okuma sürümü",
  reportReason: "Bildirim nedeni",
  reportPrivacy: "Gizlilik sorunu",
  reportRights: "Hak ihlali",
  reportUnsafe: "Güvensiz içerik",
  reportAbuse: "Kötüye kullanım",
  other: "Diğer",
  reportDetails: "Açıklama (isteğe bağlı)",
  submitReport: "Bildirimi gönder",
  reportSubmitted: "Bildirimin alındı ve incelenmek üzere kuyruğa eklendi.",
  teamSize: "Takım başına oyuncu",
  chooseTeam: "Takımını seç",
  teamFull: "Bu takım dolu",
  logoAction: "Logoyu al / bırak",
  createVersionRequired: "Çevrimiçi oda kurmak için kendi URL'inden hazırlanmış, yetkili bir harita sürümü seçmelisin.",
  creatorChallengeNeedsVersion: "Meydan okuma, kendi hazırlanmış harita sürümünden oluşturulur. Önce bir URL yakala ve sürümünü aç.",
  practiceOnlyLegacyVersion: "Bu eski harita sürümü yalnızca sıralamasız antrenmanda kullanılabilir.",
  listPublicRoom: "Odayı keşifte göster",
  inviteAccessNote: "Davet bağlantısı kimlik doğrulamasından sonra özel odaya erişim verir; herkese açık arama yapılmaz.",
  inviteNotReady: "Oda henüz başlamaya hazır değil.",
  addFavoriteDone: "Harita favorilerine eklendi.",
  removeFavoriteDone: "Harita favorilerinden çıkarıldı.",
  shareLinkReadyToCopy: "Paylaşım bağlantısı hazır; kopyalayabilirsin.",
  shareRevoked: "Paylaşım bağlantısı iptal edildi.",
  regionInvalid: "Oyun alanı geçersiz veya sayfa sınırlarının dışında.",
  phaseLoading: "Harita yükleniyor",
  phaseAborted: "Oyun iptal edildi",
  phaseClosed: "Oda kapandı",
  offlineShell: "Çevrimdışısın. Kaydedilmiş arayüz açıldı; çevrimiçi işler bağlantı gelene kadar kullanılamaz.",
  updateReady: "URLCADE için yeni bir sürüm hazır.",
  updateNow: "Şimdi güncelle",
  updateApplying: "Güncelleme başlatılıyor…",
} as const;

type MessageKey = keyof typeof trTR;
export type Locale = "tr-TR" | "en-US";

const enUS: Partial<Record<MessageKey, string>> = {
  brand: "URLCADE",
  defaultNickname: "Player",
  tagline: "Every URL is a level.",
  homeEyebrow: "Turn your URL into a playfield",
  heroTitle: "Pick a page,\ninvite your friends,\nstart playing.",
  heroDescription: "Race through Scroll Rush, hide with friends, capture the logo, brawl across the page, or take on the browser boss together.",
  homeNav: "Home",
  howNav: "How to play",
  settings: "Settings",
  settingsTitle: "Game settings",
  sound: "Sound effects",
  reducedMotion: "Reduce motion",
  visualQuality: "Visual quality",
  visualQualityHelp: "Canvas resolution and decorative particle density change; physics and online rules stay the same.",
  qualityEconomy: "Economy · lower resolution",
  qualityBalanced: "Balanced",
  qualityHigh: "High · sharper image",
  localPlay: "Play solo",
  createRoom: "Create room",
  joinRoom: "Join room",
  localLabel: "LOCAL COURSE",
  rushLabel: "SCROLL RUSH",
  hideLabel: "SITE HIDEOUT",
  hideDescription: "Two to four players. One seeker. The other players hide inside the page.",
  rushDescription: "Hit checkpoints, recover from falls, and reach the finish.",
  captureLabel: "CAPTURE THE LOGO",
  captureDescription: "Play in teams, take the logo, fend off rivals, and carry it back to your base.",
  brawlLabel: "PAGE BRAWL",
  brawlDescription: "Up to six players. Push opponents out and use breakable cover to find a route.",
  bossLabel: "BROWSER BOSS",
  bossDescription: "Activate three switches together, then reach the weak point during its open window.",
  challengeTitle: "Challenge",
  challengeDescription: "Share a prepared Scroll Rush route with matching map and movement versions.",
  challengeCreate: "Create challenge",
  challengeOpen: "Open challenge",
  challengeOption: "Prepared route",
  challengeName: "Challenge name",
  challengeNamePlaceholder: "For example, Night route",
  challengeShare: "Share link",
  challengeLeaderboard: "Best recorded runs",
  challengeGhost: "Show ghost run",
  challengeNoRecords: "No server-recorded runs yet.",
  challengeRequiresOnline: "Online services are required to create a challenge and view its server records.",
  challengeVersionUnavailable: "This challenge uses a different map or movement version and cannot run in this client.",
  challengeCreated: "Challenge created. Share the link with your friends.",
  challengeLoading: "Loading challenge from the server…",
  challengeCreationFailed: "The challenge could not be created on the server.",
  challengeStart: "Play this route",
  challengeShareCopied: "Challenge link copied.",
  challengeCopiedFallback: "Could not copy the link. Share it from the address bar.",
  challengeError: "Could not open the challenge.",
  challengeHostOnly: "Only the lobby host can choose the challenge route.",
  challengeMap: "Map summary",
  serverRecords: "SERVER RECORDS",
  challengeGhostHint: "Only server-recorded runs for this challenge can appear as ghosts.",
  ghostReplayLoading: "Loading the server ghost…",
  ghostReplayUnavailable: "No compatible server replay is available for this challenge.",
  challengeServerRecordOnly: "Times and ghosts are created only by completed authoritative server runs. Clients cannot upload records.",
  challengeIntegrityHint: "Verify map assets and SHA-256 digests before creating a challenge.",
  challengeTitleValidation: "Challenge names must be 2–60 characters.",
  challengeMapUnavailable: "This challenge map is not in the bundled catalog for this client.",
  challengeLeaderboardUnavailable: "The server leaderboard is unavailable right now.",
  challengeRoomDescription: "This invite opens a private Rush room. A matching server challenge result can enter the leaderboard.",
  modeSelect: "Choose a mode",
  modeOnlineRequired: "Online room required",
  multiplayerOnly: "These modes require an authoritative online room and are unavailable until services are configured.",
  practiceStart: "Try solo",
  practiceStarting: "Preparing…",
  practiceUnranked: "PRIVATE PRACTICE · UNRANKED",
  practiceUnrankedAction: "Unranked practice",
  practiceVerifyingMap: "Verifying map digest and version…",
  practiceConnecting: "Opening a secure practice room…",
  practicePreparing: "Preparing map…",
  practicePrivacy: "Join a one-player server room with your real account. Practice creates no rank, challenge record, or ghost.",
  practiceLobby: "Single-player practice. Results are not saved or ranked.",
  practiceResult: "Practice complete. No score or rank was saved.",
  practiceHider: "Try hider role",
  practiceSeeker: "Try seeker role",
  practiceRoleLabel: "Practice role",
  practiceDummy: "Practice dummy",
  captureObjective: "Carry the logo from the rival base to yours three times.",
  logoCenter: "Logo at center",
  logoCarried: "Logo carried",
  logoDropped: "Logo dropped",
  logoYouCarry: "You are carrying the logo",
  logoCarrier: "{name} is carrying the logo",
  logoReturnsIn: "Returns to center in {seconds}s",
  logoTooFar: "Move closer to pick up the logo.",
  redTeam: "Red team",
  blueTeam: "Blue team",
  pushAction: "Push",
  pushHint: "Push a nearby rival",
  actionCooldown: "Push cooldown",
  spawnProtected: "Spawn protection",
  stunned: "Stunned",
  captureScore: "Captures",
  capturePlayerCount: "2 vs 2 or 3 vs 3",
  brawlObjective: "Push opponents out in three minutes. Tied players share rank.",
  areaBurst: "Area burst",
  burstCooldown: "Area burst cooldown",
  fallPoints: "Knockouts",
  breakableRebuild: "Cover rebuilding",
  bossObjective: "Activate the switches, then reach the weak point during its eight-second window.",
  bossSwitches: "Switch",
  bossWeakWindow: "Weak point open",
  bossCycles: "Cycles cleared",
  bossProgress: "Team progress",
  bossRescues: "Rescues remaining",
  bossTelegraph: "Attack area marked",
  interact: "Interact",
  interactShort: "Hold E",
  bossPlayerCount: "1–4 players · co-op",
  challengePlayerCount: "1–4 players · challenge",
  redTeamWon: "Red team wins.",
  blueTeamWon: "Blue team wins.",
  matchDraw: "The match ended in a tie.",
  bossVictory: "Boss defeated. The team cleared all three cycles.",
  bossDefeat: "The boss encounter was not completed.",
  nickname: "Nickname",
  nicknameHint: "2–18 characters · shown in this match only",
  roomCode: "Room code",
  roomCodeHint: "The eight-character code shared by your friend",
  continue: "Continue",
  cancel: "Cancel",
  close: "Close",
  chooseMap: "Choose a page",
  chooseMapDescription: "These original page copies are prepared for play.",
  loadingMaps: "Loading maps…",
  noMaps: "No local map packages yet.",
  noMapsDescription: "Maps will appear here after packages are added. Online rooms also require a map.",
  loadFailed: "Could not load the map list.",
  retry: "Try again",
  localBest: "Best on this device",
  noLocalBest: "No time yet",
  localRushOnDevice: "Play this version on this device",
  showBestGhost: "Show your best run",
  hideBestGhost: "Hide your best run",
  bestGhostLoading: "Loading your best run…",
  bestGhostMissing: "You have no saved run for this version.",
  startLocal: "Start course",
  multiplayerUnavailable: "Online play is not configured right now.",
  missingServices: "Creating a room requires the game server and a Supabase anonymous session. Online play becomes available when configured.",
  createTitle: "Invite your friends",
  joinTitle: "Enter a room code",
  createDescription: "Create a private room and share its invite with the people you choose.",
  joinDescription: "Use your friend's room code or invite link.",
  lobbyTitle: "Room lobby",
  lobbyWaiting: "Waiting for players",
  mapLoading: "Loading map assets",
  ready: "Ready",
  notReady: "Not ready",
  startGame: "Start game",
  copyInvite: "Copy invite link",
  copied: "Invite link copied",
  room: "Room",
  host: "Host",
  loadingAsset: "Loading map",
  mapVersion: "Map version",
  versionMismatch: "The client and room versions do not match. Refresh and try again.",
  assetMismatch: "This room's map version could not be loaded. Continuing with another version is unsafe.",
  multiplayerError: "Could not connect to the room.",
  matchDisconnected: "Connection lost. The room is waiting for reconnection.",
  resumeRoom: "Reconnect to room",
  leaveRoom: "Leave room",
  rematch: "Request rematch",
  backHome: "Back to home",
  backToModeSelection: "Back to mode selection",
  results: "Match result",
  matchHistory: "Match history",
  noHistory: "No local course result on this device yet.",
  privacyNote: "Local times are stored only in this browser; they are not shared as online records.",
  yourTime: "Your time on this device",
  dnf: "Course not finished",
  penalty: "Fall penalty",
  checkpoints: "Checkpoints",
  pause: "Pause",
  resume: "Resume",
  jump: "Jump",
  dash: "Dash",
  scan: "Scan",
  transform: "Transform",
  selectProp: "Choose a nearby disguise",
  caught: "Caught. Wait until the round ends.",
  hidden: "Disguised",
  hider: "Hider",
  seeker: "Seeker",
  energy: "Scan energy",
  searchTime: "Search time",
  hint: "Approximate area hint",
  portraitMode: "Turn your device sideways for a more comfortable game.",
  inputHelp: "Move: A/D or ←/→ · Jump: Space · Dash: Shift",
  hideInputHelp: "Move: A/D or ←/→ · Jump: Space · E: choose disguise · F: transform · Tap to scan",
  captureInputHelp: "Move: A/D · Jump: Space · Dash: Shift · Q: push · E: take or drop the logo",
  brawlInputHelp: "Move: A/D · Jump: Space · Q: push · R: area burst",
  bossInputHelp: "Move: A/D · Jump: Space · E: switch or hold at weak point",
  networkConnecting: "Connecting to server…",
  authConnecting: "Preparing anonymous session…",
  roomCreated: "Private room created.",
  roomJoined: "Joined room.",
  roomFull: "This room is full.",
  invalidNickname: "Nickname must be 2–18 characters.",
  invalidRoomCode: "Room codes contain eight letters or numbers.",
  copyFailed: "Could not copy automatically. Select and copy the invite link field.",
  closeDialog: "Close dialog",
  historyTitle: "Times on this device",
  historyClear: "Clear history",
  historyClearConfirm: "Delete local course times from this browser?",
  historyCleared: "Local times cleared.",
  soundMute: "Mute sound effects",
  soundEnable: "Enable sound effects",
  browserWithFriends: "In your browser, together",
  privateInviteHint: "Private rooms use invite links; there is no random room search.",
  allFiveModes: "Five game modes",
  chooseHowToPlay: "Different games from the same page",
  pageSnapshot: "Page game copy",
  chooseCharacter: "Choose a character",
  captureTeam: "Your team",
  pushNoTarget: "No nearby rival to push.",
  bossNoTarget: "No nearby switch or reachable weak point.",
  verifyMap: "Verify map",
  playerLimitHint: "The room needs {min}–{max} players to start.",
  resumeRoomRequired: "This room is not open in this session. Rejoin from its invite link.",
  shareLink: "Share link",
  shareExpires: "Link expires",
  copy: "Copy",
  revokeShare: "Revoke link",
  mapPreviewDescription: "Inspect the verified version. Private assets load only in an authorized session.",
  noMapVersion: "This map version is unavailable.",
  loadAuthorizedPreview: "Load private preview",
  editMap: "Edit play area",
  previewPrivateNotice: "The preview appears after authorized assets load.",
  pageSnapshotPreview: "Page game-copy preview",
  creatorTools: "Creator tools",
  boundedMapEditing: "Crop the play area within its bounds or create a mode adaptation.",
  creatorSetup: "Gameplay layout",
  creatorPatchInvalid: "The edit fields are invalid. Check coordinates, counts, and selected items.",
  spawnPoint: "Spawn point",
  checkpoint: "Checkpoint",
  checkpointCount: "Checkpoint count",
  finishLine: "Finish area",
  timeLimitMs: "Time limit (milliseconds)",
  seekerSpawn: "Seeker spawn",
  hiderSpawn: "Hider spawn",
  decoyCount: "Decoy count",
  disguisePool: "Disguise pool",
  teamSpawnCount: "Spawn points per team",
  redDeliveryZone: "Red delivery zone",
  blueDeliveryZone: "Blue delivery zone",
  logoSpawn: "Logo position",
  safeSpawn: "Safe spawn",
  breakableSelection: "Destructible objects",
  attackZoneCount: "Attack zone count",
  attackZone: "Attack zone",
  weakPoint: "Weak point",
  supportPalette: "Support platform palette",
  supportPaletteHelp: "Select up to six platforms. Coordinates are validated against the captured area and server physics limits.",
  supportPlatform: "Add platform",
  supportBounds: "Platform area",
  previewRequiresAccess: "Load the authorized private preview before editing.",
  modeLabel: "Game mode",
  selectedRegion: "Play-area bounds",
  regionX: "Horizontal start",
  regionY: "Vertical start",
  regionWidth: "Width",
  regionHeight: "Height",
  worldBounds: "Source area",
  regionNeedsPreview: "Load the private preview to see the play-area bounds.",
  creatorRegionPreviewOnly: "A region preview creates a separate version; layout edits are not saved in this step. When it is ready, open that version and apply the edits there.",
  creatorRegionPreviewRequired: "First create a region preview in the map editor, then create a challenge draft from that version. Edits here have not been saved.",
  creatorRegionFullWidth: "The full source width is fixed at {width} px.",
  creatorRegionTileRangeLabel: "Complete source-image range",
  creatorRegionTileRangeHelp: "Only full-width, contiguous source-image ranges verified from the loaded immutable version are offered. Cut boundaries are never rounded automatically.",
  creatorRegionTileRangeOption: "{start}–{end} px · {height} px high",
  creatorRegionTileRangeCurrent: "The current {start}–{end} px range is not available as a safe selection.",
  creatorRegionTileRangeCurrentInvalid: "The current value is preserved; choose a complete range below before previewing.",
  creatorRegionTileRangeUnavailable: "No selectable complete image boundary could be verified in this version. No preview is submitted until a safe range is available.",
  creatorRegionWholeTilesRequired: "The selected region does not match complete source-image boundaries. Choose a complete source-image range and try again.",
  creatorCreateRegionPreview: "Create region preview",
  sourceBoundsUnavailable: "Source-page bounds could not be loaded; map-owner access is required for safe version editing.",
  savingVariant: "Preparing new version…",
  createVariant: "Create version",
  creatorChallengeDraft: "Challenge draft",
  creatorChallengePrivacy: "Drafts and versions stay private by default. Public release requires review.",
  description: "Description",
  createCreatorDraft: "Create draft",
  creatorDraftCreated: "Private draft created.",
  shareChallenge: "Share challenge",
  saveNewVersion: "Create challenge version",
  creatorPatchBounded: "A new version uses only the verified play area and selected mode.",
  challengeRemoved: "This challenge was removed or its access was revoked.",
  challengeVersion: "Challenge version",
  regionInvalid: "The play area is invalid or outside the page bounds.",
  phaseLoading: "Loading map",
  phaseAborted: "Match cancelled",
  phaseClosed: "Room closed",
  offlineShell: "You are offline. The saved app shell is open; online actions need a connection.",
  updateReady: "A new URLCADE version is ready.",
  updateNow: "Update now",
  updateApplying: "Starting the update…",
  library: "Library",
  libraryLoading: "Loading your private library…",
  privateContent: "Your private content",
  libraryPrivacy: "Private maps and favorites belong to your account. Source links are not shared.",
  favoritesOnly: "Favorites only",
  mapsCount: "maps",
  libraryEmpty: "Your library is empty",
  libraryEmptyHelp: "Enter a page URL to create a private game copy.",
  newUrlCapture: "Capture a page",
  mapExpired: "This map has expired.",
  openMap: "Open map",
  addFavorite: "Add to favorites",
  removeFavorite: "Remove favorite",
  discover: "Discover",
  discoverLoading: "Loading published maps and open rooms…",
  discoverPolicy: "Only approved public maps and rooms open to players are shown.",
  filterByMode: "Filter by mode",
  allModes: "All modes",
  publicMaps: "Published maps",
  discoverEmpty: "No public maps match this filter.",
  loadMore: "Load more",
  publicRooms: "Open rooms",
  noPublicRooms: "There are no rooms open to join right now.",
  publicOnly: "Community",
  completedMatches: "completed matches",
  playerCount: "players",
  profile: "Profile",
  profileLoading: "Loading your profile…",
  profileUnavailable: "Could not open your profile.",
  profileIdentityPrivacy: "Your anonymous identity is preserved when you upgrade. Source page links stay private.",
  interfaceLanguage: "Interface language",
  profileInputInvalid: "Nickname, character, or language is invalid.",
  savingProfile: "Saving profile…",
  saveProfile: "Save profile",
  profileSaved: "Profile updated.",
  guestAccount: "Guest account",
  permanentAccount: "Permanent account",
  upgradeAccount: "Upgrade with email",
  upgradeAccountPrivacy: "Secure your session with email and password while keeping the same user ID.",
  requestEmailLink: "Send confirmation email",
  emailConfirmationInstructions: "Open the email confirmation link. After this profile returns with the same user ID, complete the separate password step.",
  setAccountPassword: "Set password",
  accountPasswordSaved: "Your password was saved; your account keeps the same user ID.",
  accountEmailInvalid: "Enter a valid email address.",
  accountPasswordInvalid: "Your password must be 10–128 characters.",
  accountEmailNotConfirmed: "Complete the email confirmation link first, then set a password.",
  accountUpgradeFailed: "The account could not be updated. Try again with the same session.",
  email: "Email",
  password: "Password",
  upgrading: "Updating account…",
  accountIdentityPreserved: "Your account identity is preserved.",
  accountUpgradeAccepted: "The account update was sent to the provider. Check your inbox if email confirmation is required.",
  deleteAccount: "Delete account",
  deleteAccountAction: "Delete my account and private content",
  deleteAccountWarning: "Your profile, private maps, favorites, and server match history will be permanently deleted. Local course records and settings on this device will remain.",
  deleteAccountConfirm: "Permanently delete your account and the private content linked to it? This action cannot be undone.",
  deletingAccount: "Deleting account…",
  accountDeleted: "Your account and linked private content have been deleted.",
  accountDeleteFailed: "Your account could not be deleted. Check your session and connection, then try again.",
  admin: "Administration",
  adminLoading: "Loading operations summary…",
  adminRestricted: "This area is available to authorized administrators only.",
  adminTools: "Trust and operations",
  adminSafetyNote: "Private source URLs are hidden. Every change is recorded with a reason.",
  activeJobs: "Active jobs",
  activeRooms: "Active rooms",
  capturesToday: "Captures today",
  recentJobs: "Recent capture jobs",
  noAdminJobs: "No jobs to show.",
  contentReports: "Content reports",
  noReports: "No open reports.",
  dismissReport: "Dismiss report",
  takedown: "Remove content",
  sourcePolicy: "Source-host policy",
  sourceHost: "Host name",
  policyAction: "Action",
  blockHost: "Block captures",
  allowHost: "Allow captures",
  policyReason: "Reason",
  savePolicy: "Save policy",
  adminReasonRequired: "Reason must be 3–500 characters.",
  reportContent: "Report content",
  reportReason: "Report reason",
  reportPrivacy: "Privacy issue",
  reportRights: "Rights violation",
  reportUnsafe: "Unsafe content",
  reportAbuse: "Abuse",
  other: "Other",
  reportDetails: "Details (optional)",
  submitReport: "Send report",
  reportSubmitted: "Your report was received and added for review.",
  shareLinkReadyToCopy: "Share link is ready to copy.",
  shareRevoked: "Share link revoked.",
  addFavoriteDone: "Map added to favorites.",
  removeFavoriteDone: "Map removed from favorites.",
  teamSize: "Players per team",
  chooseTeam: "Choose your team",
  teamFull: "This team is full",
  logoAction: "Take / drop logo",
  createVersionRequired: "Create an online room from an authorized map version captured from a URL you chose.",
  creatorChallengeNeedsVersion: "Create a challenge from one of your captured map versions. Capture a URL and open its version first.",
  practiceOnlyLegacyVersion: "This older map version is available for unranked practice only.",
  listPublicRoom: "Show room in Discover",
  inviteAccessNote: "The invite grants access to a private room after authentication. No public room search is used.",
  inviteNotReady: "The room is not ready to start yet.",
  localAndOnline: "Local and online",
  localCourses: "Local courses",
  onlineMatches: "Online matches",
  onlineResult: "server result",
  historyDescription: "Local course times stay on this device. Online match results come from the server.",
  localSettings: "Preferences are stored only in this browser.",
  personalPreferences: "Personal preferences",
  localSoundsDescription: "Short local effects. No audio is streamed.",
  reducedMotionDescription: "Reduce camera easing and decorative animation.",
  anonymousSessionNote: "Anonymous session · protected by Supabase Auth",
  historyLoading: "Loading results…",
  noOnlineHistory: "No online matches yet.",
  localOnlyResult: "Local result",
  resultSaved: "Result saved by the server.",
  resultSaving: "The server is saving the result…",
  resultUnconfigured: "Server result storage is not configured.",
  resultFailed: "The server could not save this result.",
  phaseCountdown: "Starting soon",
  phaseHiding: "Hide",
  phaseSearching: "Search",
  phaseRacing: "Race",
  phaseRoundResult: "Round result",
  phasePaused: "Paused",
  phasePlaying: "Playing",
  courseComplete: "Course complete",
  timeExpired: "Time expired",
  localCourseResult: "Local course result",
  playAgain: "Play again",
  rankPlace: "place",
  points: "points",
  routeToFinish: "route to finish",
  firstTwoModes: "Play spaces",
  twoGames: "Five games begin with a page.",
  modesDescription: "Each mode turns the same prepared page into a different challenge. Solo courses and private online rooms are separate.",
  goToCourse: "Go to course",
  roomSetup: "Set up a room",
  mapDigestLoading: "Checking image files and digests…",
  privateRoom: "Private invite room",
  inviteLink: "Invite link",
  exampleNickname: "For example, BlueCat",
  nicknameInputHint: "2–24 characters · letters, numbers, spaces, dots, hyphens, underscores",
  gameMode: "Game mode",
  hideNeedsFour: "Two to four players are required to start.",
  rushPlayerCount: "2–4 players, private room.",
  noMapForMode: "No packaged map is available for this mode.",
  mapsReady: "maps",
  multiplayerCreateDisabled: "Online rooms stay disabled until services are ready.",
  multiplayerJoinDisabled: "Joining stays disabled until services are ready.",
  noMapOption: "No suitable map",
  roomPlayers: "Players",
  connected: "Connected",
  waitingConnection: "Waiting for connection",
  waiting: "Waiting",
  assetsNeedChecking: "Verify assets before becoming ready.",
  mapVersionPinned: "Map version is pinned. Everyone must load the same files before readying.",
  mapPreparing: "Preparing map",
  mapMustLoad: "Load the map before readying.",
  loadedReady: "Map and assets verified. Mark ready when you are.",
  convertThisPage: "Turn this page into a game",
  conversionSubmitting: "Sending request…",
  urlInputLabel: "Page URL to play",
  urlInputHelp: "Paste the full page link. It is normalized to HTTPS and checked by the server.",
  urlPrivacyNote: "Your browser session and cookies are never used. Maps are private by default.",
  conversionTitle: "Preparing your page",
  conversionPrivateNotice: "Only you can see this conversion request. The source URL stays private.",
  conversionNoSourceLeak: "The full address is hidden for privacy.",
  conversionLoading: "Getting job status from the server…",
  conversionProgress: "Completed steps",
  conversionLoadFailed: "Could not load conversion status.",
  conversionReadyCopy: "Your page snapshot and supported modes are ready.",
  openGameCopy: "Open map preview",
  cancelConversion: "Cancel job",
  retryConversion: "Retry",
  refreshStatus: "Refresh status",
  phaseQueued: "Queued",
  phasePolicyCheck: "Safety and access check",
  phaseCapturing: "Capturing page",
  phaseExtracting: "Extracting page geometry",
  phaseCompiling: "Preparing game modes",
  phasePackaging: "Packaging map files",
  phaseReady: "Map ready",
  phaseRejected: "This address cannot be processed right now",
  phaseFailed: "Job could not be completed",
  phaseCancelled: "Job cancelled",
  phaseExpired: "Request expired",
  urlInvalid: "Enter a valid page URL.",
  urlSchemeUnsupported: "Only HTTP and HTTPS pages can be processed.",
  urlTargetBlocked: "This address does not meet safe-access rules.",
  urlSecretBlocked: "The URL contains a private signature or access key. Use a public page URL.",
  urlPolicyBlocked: "This source cannot be processed under product access policies.",
  urlAuthRequired: "The source requires sign-in. URLcade never collects source cookies or passwords.",
  urlChallengeBlocked: "The source requires CAPTCHA or bot verification. The check is not bypassed.",
  urlContentUnsupported: "This page type is not supported for capture.",
  urlCaptureTimeout: "Page capture exceeded its time limit.",
  urlCaptureLimit: "Page capture exceeded resource limits.",
  urlCaptureUnstable: "The page did not load enough to create a stable snapshot.",
  urlNoModes: "No playable mode was found for this page. Try another section or URL.",
  urlQuota: "Capture quota reached. Try again later.",
  urlQueueFull: "Capture queue is full. No request was accepted; try again later.",
  captureNotConfigured: "Page capture is not configured. The server will not fabricate a result.",
  accessRevoked: "Access to this content was revoked or expired.",
  sourceRemoved: "The source was removed at the owner's request.",
  statusPending: "Result storage is pending.",
  conversionGenericError: "Could not complete the request. Refresh status and try again.",
  mapDetails: "Page copy",
  authorizedMapLoading: "Checking map access…",
  mapUnavailable: "This map is unavailable or its version was removed.",
  capturedAt: "Captured",
  snapshotImmutable: "This game copy is an immutable version.",
  authorizedPreviewPending: "Private previews load through authorized file access.",
  saveToLibrary: "Save to my library",
  savedToLibrary: "Map saved to your library.",
  recapturePage: "Capture page again",
  privateMapAssets: "Private images load only through authorized access and are never stored in the public cache.",
  mapVisibility: "Visibility",
  sourcePage: "Source page",
  sourceSectionSelected: "The first suitable {height}-pixel section of the page was used for the play area.",
  noDescription: "No description was added.",
  mapVersions: "Map versions",
  modeSuitability: "Modes supported by this page",
  noModes: "The server has not reported a playable mode.",
  preview: "Preview",
  suitabilitySupported: "Supported",
  suitabilityAdapted: "Adapted",
  suitabilityUnavailable: "Unavailable",
  suitabilityReady: "No additional restrictions were reported for this version.",
  suitabilityReasonGeneric: "This mode needs additional requirements.",
  playerSingle: "player",
  players: "players",
  modeChooseHeading: "How should we play this page?",
  modeChooseDescription: "All five modes are checked against the real play area captured from this page. Choose an available mode to open the matching private map version and preview.",
  modePreviewTitle: "Selected mode",
  selectedMapVersion: "Map version",
  mapToolsSummary: "Map actions and history",
  mapToolsVersionHistory: "Created versions",
  modeVersionUnavailable: "There is no compatible playable version for this mode yet.",
  modeUnavailableHint: "No playable version",
  modeAdaptedFallback: "The source page was shaped to meet this mode’s gameplay rules.",
  modeNativeFallback: "The source page appearance is preserved; no additional game layer is used.",
  reason_SOURCE_ROUTE_SUPPORTED: "A small set of support platforms was added to bridge gaps in the course.",
  reason_SOURCE_PROP_VARIETY_ADAPTED: "Additional prop looks were added for hide-and-seek.",
  reason_CAPTURE_OBJECTIVES_ADAPTED: "Separate team target areas and a game-owned objective were added.",
  reason_BRAWL_COVER_ADAPTED: "A small set of breakable game covers was added over the preserved page view.",
  reason_BOSS_OBJECTIVES_ADAPTED: "Boss art and interaction targets were added for the encounter.",
  modeReasonRush: "No connected course from a safe start point to the finish could be built.",
  modeReasonHide: "There are not enough distinct hiding spots connected by safe surfaces.",
  modeReasonCapture: "Two team areas, source logo art, and balanced routes could not all be built.",
  modeReasonBrawl: "The page has no safe breakable props, permanent ground, or reachable arena.",
  modeReasonBoss: "Three switch regions, boss art, and a reachable arena could not all be built.",
  reason_support_platform: "Support platforms were added to bridge gaps in the course.",
  reason_creator_support: "Support platforms were added to bridge gaps in the course.",
  reason_route_gap: "A gap between source surfaces was bridged with safe supports.",
  reason_creator_patch: "Support surfaces were added for the chosen play area.",
  noPlayableMapMode: "No game mode is playable on this page.",
  noPlayableMapModeDescription: "Each mode needs real page surfaces, routes, or objectives. Try another page and capture it again.",
  modeOnlineUnavailable: "Online rooms and server practice are not configured right now, so play cannot start in this mode.",
  previewLoadFailed: "This private map version could not be loaded.",
  modePreviewRetry: "Load preview",
  playSoloRush: "Play Scroll Rush solo",
  reason_SUPPORT_PLATFORMS_ADDED: "Support platforms were added to connect the course.",
  reason_CREATOR_SUPPORTS_ADDED: "Support platforms were added to connect the course.",
  reason_RUSH_PLATFORM_DENSITY: "This section does not have enough jump platforms for a course.",
  reason_RUSH_SPAWN_UNSUPPORTED: "A safe platform could not be used for the start point.",
  reason_RUSH_ROUTE_UNREACHABLE: "A continuous route from the start to the finish could not be built.",
  reason_HIDE_VISIBLE_VARIETY_LOW: "There are not enough different, visible hiding spots.",
  reason_HIDE_DECOY_SURFACES_MISSING: "There are no suitable page surfaces for hiding players.",
  reason_HIDE_PLAYABLE_NETWORK_UNREACHABLE: "A safe network between the hiding areas could not be built.",
  reason_HIDE_CONNECTIVITY_SEARCH_BOUNDED: "The hiding areas could not be verified as connected.",
  reason_DECOY_PLACEMENT_UNSUITABLE: "Disguise points cannot be placed on safe surfaces.",
  reason_CAPTURE_ARENA_REQUIREMENTS_MISSING: "Two team areas or source logo art could not be found.",
  reason_ARENA_PATH_INVALID: "The team routes in the arena could not be verified against page surfaces.",
  reason_CAPTURE_TEAM_ROUTE_UNREACHABLE: "There is no reachable logo route between the team areas.",
  reason_CAPTURE_ALTERNATE_ROUTES_MISSING: "Balanced alternate routes for the teams could not be built.",
  reason_CAPTURE_CONNECTIVITY_SEARCH_BOUNDED: "Balanced alternate routes were not found within the bounded route search.",
  reason_ADAPTATION_BUDGET_EXCEEDED: "Making this page playable would require too many artificial platforms.",
  reason_CAPTURE_CRITICAL_PATH_TOO_COMPLEX: "The main routes for both teams are too complex to verify safely.",
  reason_CAPTURE_ROUTE_COST_UNBALANCED: "The teams’ routes to the logo are not balanced.",
  reason_CAPTURE_OBJECTIVE_UNREACHABLE: "The source logo cannot be placed where both teams can reach it.",
  reason_BRAWL_SAFE_DESTRUCTIBLES_MISSING: "There are no real page props that can be safely broken.",
  reason_BRAWL_SPAWN_SURFACES_MISSING: "There are not enough safe surfaces for player starts.",
  reason_BRAWL_PERMANENT_GROUND_MISSING: "No permanent ground could be found for the arena.",
  reason_BRAWL_CRITICAL_PATH_UNREACHABLE: "There is no verified route for players to move through the arena.",
  reason_BREAKABLE_INVALID: "The safe bounds of breakable page props could not be verified.",
  reason_BOSS_ARENA_REQUIREMENTS_MISSING: "Boss art or player start areas could not be found.",
  reason_BOSS_CRITICAL_PATH_UNREACHABLE: "A route through the boss arena could not be built.",
  reason_BOSS_SWITCH_REGIONS_MISSING: "Three separate switch regions could not be found.",
  reason_BOSS_TARGET_UNREACHABLE: "The boss weak point is not in a reachable location.",
  reason_REGION_WIDTH_UNSUPPORTED: "This section is not wide enough for this mode.",
  reason_CAPTURE_ASSETS_MISSING: "The source page did not provide the art needed for this arena.",
  reason_ARTIFACT_ASSET_BUDGET_EXCEEDED: "The safe image limit for this map was exceeded.",
  reason_VISUAL_LAYER_BUDGET_EXCEEDED: "This page exceeds the safe limit for usable visual props.",
  reason_CAPTURE_BUNDLE_INVALID: "The game copy of the source page could not be verified.",
  reason_CAPTURE_HEIGHT_LIMIT: "This section is too tall to become one playable course.",
  reason_MODE_LAYOUT_UNAVAILABLE: "A safe play area could not be extracted from this section.",
  reason_REGION_INVALID: "The selected page region is outside safe bounds.",
  reason_REGION_NOT_FOUND: "The selected page section was not found in the captured image.",
  reason_SPAWN_UNSUPPORTED: "A start point cannot be placed on a suitable page surface.",
  reason_SPAWN_BLOCKED: "Page props block the start point.",
  reason_TARGET_UNSUPPORTED: "The game objective cannot be placed safely on this page.",
  reason_UNREACHABLE_ROUTE: "No route to the game objectives was found.",
  reason_WORLD_INVALID: "The play area bounds could not be verified.",
  reason_CRITICAL_PATH_INVALID: "The main player route could not be verified.",
  reason_MODE_LAYOUT_INVALID: "The page layout could not be resolved safely for this mode.",
  reason_NO_COLLIDERS: "There are no page surfaces for players to stand on.",
  reason_NO_PROPS: "There are no visible page props to use for hiding or arena objectives.",
  reason_HIDE_PROPS: "There are not enough visible page props for hiding.",
  reason_MISSING_ASSET: "A required page image is missing from the game copy.",
  reason_MISSING_MODE_ASSET: "An image required for this mode could not be found.",
  reason_SPAWN_OUTSIDE_WORLD: "The start point is outside the play area.",
  reason_COLLIDER_OUTSIDE_WORLD: "A page surface is outside the safe play area.",
  reason_TILE_OUTSIDE_WORLD: "A page image is outside the safe play area.",
  reason_ZONE_OUTSIDE_WORLD: "A game zone is outside the safe play area.",
  visibilityPrivate: "Private",
  visibilityUnlisted: "Unlisted",
  visibilityPublic: "Public",
  sharePrivateMap: "Create access link",
  requestPublication: "Request publication review",
  publicationPendingReview: "Publication is pending review; the map is not visible in Discover yet.",
  publicationStatusUpdated: "Publication status updated by the server.",
  mapLabel: "Map",
  mapDigestReady: "Map images verified.",
  primaryNavigation: "Primary navigation",
  brandHomeLabel: "URLCADE home page",
  artPageTitle: "Every tab is a playfield.",
  artNavRace: "Race",
  artNavHide: "Hide",
  artNavTogether: "Together",
  assetDigestError: "The asset digest did not match the manifest.",
  assetInvalidError: "A map image could not be decoded safely.",
  assetMissingError: "A required map image is missing.",
  assetTooLargeError: "A map image exceeds its size limit.",
  authCreateFailed: "Could not create an anonymous session.",
  authReadFailed: "Could not read the current session.",
  availableModesLoading: "Loading available game modes…",
  avatarSelf: "You",
  brawlPlayerCount: "2–6 players",
  catalogDuplicate: "The map catalog contains a duplicate entry.",
  catalogEntryInvalid: "A map catalog entry is invalid.",
  catalogFormatInvalid: "The map catalog could not be read.",
  catalogPathInvalid: "The map catalog contains an unsafe file path.",
  catalogUrlInvalid: "The map catalog contains an invalid URL.",
  caughtWait: "You were caught. Wait for the round to finish.",
  challengeOptionMissing: "This map has no prepared Rush route to share.",
  checkpointProgress: "checkpoint · 02/03",
  connectionRestored: "Connection restored.",
  courseModeMismatch: "This map is not a Scroll Rush course.",
  cryptoNeeded: "Secure browser crypto is required to verify map assets.",
  cryptoRequiredError: "Secure browser crypto is unavailable. Map verification cannot continue.",
  errorAuth: "The anonymous session could not be verified. Try reconnecting.",
  errorForbidden: "This action is not available right now.",
  gameActionUnavailable: "The game state may have changed. Follow the on-screen prompt and try again.",
  errorGeneric: "The request could not be completed.",
  errorMatchAborted: "The match ended because a connection could not be restored.",
  errorNotReady: "All players must be ready and the map must be loaded.",
  errorRateLimited: "Too many requests. Wait a moment and try again.",
  errorRoomActive: "The match has started; this room can no longer be joined.",
  errorRoomFull: "This room is full.",
  errorRoomMissing: "This room could not be found.",
  errorVersionMismatch: "The room and map versions do not match.",
  exitGame: "Leave game",
  finishLabel: "FINISH",
  founder: "Host",
  gameNotConfigured: "Online game services are not configured.",
  gameReadyAnnouncement: "Game ready. Use the controls to move.",
  ghostActive: "Hide ghost",
  ghostLabel: "Ghost run",
  ghostReplayVersion: "A ghost is shown only with the same map and movement version.",
  hashMismatch: "This challenge is registered on the server with a different map digest.",
  heroArtworkLabel: "URLCADE · PLAY SPACE",
  hideNeedsFourHelp: "This mode starts with two to four players: one seeker and the remaining players are hiders.",
  hidePlayerCount: "Two to four players, private room.",
  hidersWon: "The hiders won this round.",
  seekerWon: "The seeker won this round.",
  hintSignal: "The scan found a hint.",
  historyLoadFailed: "Could not load match history.",
  imageUnavailable: "A map image is unavailable.",
  localMapLabel: "local map · game copy",
  localMapMissing: "No map is available for this mode.",
  mapAddressInvalid: "The map manifest address is invalid.",
  mapAssetEscaped: "A map asset points outside its version folder.",
  mapCatalogMismatch: "The map does not match the catalog entry.",
  mapContractInvalid: "The map manifest is not supported by this client.",
  mapDigestMismatch: "The map digest did not match.",
  mapFileTooLarge: "A map file exceeds its limit.",
  mapFileUnavailable: "A map file could not be loaded.",
  mapForRushOnly: "The selected map is not a Scroll Rush course.",
  mapImageInvalid: "A map image is invalid.",
  mapJsonInvalid: "The map manifest is invalid JSON.",
  mapLoadFailed: "Could not load the map.",
  mapPackageTooLarge: "The complete map package exceeds its size limit.",
  mapSelectionInvalid: "Choose a supported map.",
  mapVersionIncompatible: "The map version is not compatible with this client.",
  moveLeft: "Move left",
  moveRight: "Move right",
  movementControls: "Movement controls",
  nearPropHelp: "Move closer to a page item; press E to choose its appearance.",
  nextRoundRoles: "Roles switch next round.",
  nicknameFormatInvalid: "Nickname must be 2–24 characters and may contain letters, numbers, spaces, dots, hyphens, or underscores.",
  nicknameValidation: "Enter a nickname using 2–24 letters, numbers, spaces, dots, hyphens, or underscores.",
  noNearbyScanTarget: "No nearby scan target.",
  hideActionWaiting: "Game state is loading. Try again in a moment.",
  hideHiderOnly: "E and F are available to the hider role only.",
  hideSeekerOnly: "Scanning is available to the seeker role only.",
  hideHiderPhase: "E and F are available during the Hiding or Search phase.",
  hideScanPhase: "Scanning is available during the Search phase only.",
  hideChooseProp: "Move near a page item and press E to choose an appearance first.",
  hideLandToTransform: "Land before pressing F to transform.",
  hideStopToTransform: "Stop moving before pressing F to transform.",
  hideTransformCooldown: "Wait {seconds}s before transforming again.",
  hideBreakDisguise: "Press F to return to your character's normal appearance.",
  hideTransformReady: "Press F to use the selected appearance.",
  hideScanCooldown: "Wait {seconds}s before scanning again.",
  hideScanEnergy: "Wait for your scan energy to recharge.",
  hideScanGuidance: "Use Scan to check the nearby area.",
  playArea: "Play area",
  privateRoomShort: "Private room",
  racePlayerCount: "1-player online run · 2–8 player race",
  reconnectAttempt: "Reconnecting…",
  reconnectFailed: "Could not reconnect to the room.",
  reconnectSeatUnavailable: "Your room seat is no longer available.",
  rematchRequested: "Rematch requested.",
  resultShapeInvalid: "Match history data could not be read.",
  roomActionFailed: "The room could not complete that action.",
  roomCodeFormatInvalid: "Room codes contain eight letters or numbers.",
  roomCodeValidation: "Enter the eight-character room code.",
  roomConnectionError: "Could not connect to the room server.",
  roomMapCatalogMismatch: "This room's map is not available in the verified catalog.",
  roomMapMissingFromCatalog: "The selected map is missing from the catalog.",
  roomModeInvalid: "The selected mode is not available.",
  roomResponseInvalid: "The server returned an invalid room response.",
  roundComplete: "Round complete.",
  roundCompleted: "Round completed",
  rushNeedsTwoHelp: "This room needs at least two players to start.",
  rushChallengeSoloLobby: "This challenge can start with one player.",
  sceneNeedsLoadedMap: "Load the verified map before opening the game.",
  sceneNeedsMap: "The verified map is not ready yet.",
  scoreAndPenalty: "Score and penalty",
  scrollRushMaps: "Scroll Rush maps",
  serverNotConfigured: "The game server is not configured.",
  shareLinkCopied: "The server-provided share link was copied.",
  temporaryHint: "Temporary hint",
  unsupportedRoomError: "This room is not supported by the current client.",
};

export function getLocale(): Locale {
  try { return localStorage.getItem("urlcade:locale") === "en-US" ? "en-US" : "tr-TR"; }
  catch { return "tr-TR"; }
}

export function setLocale(locale: Locale): void {
  try { localStorage.setItem("urlcade:locale", locale); } catch { /* browser storage may be disabled */ }
  if (typeof document !== "undefined") {
    document.documentElement.lang = locale === "en-US" ? "en" : "tr";
    const copy = locale === "en-US"
      ? { title: "URLCADE — Every URL is a level", description: "Turn a page you choose into a game. Race, hide, play as a team, or face the browser boss with friends.", social: "Pick a page, invite your friends, start playing." }
      : { title: "URLCADE — Sayfalar oyuna dönüşüyor", description: "Seçtiğin sayfayı oyuna dönüştür. Arkadaşlarınla yarış, saklan, takım ol veya tarayıcı patronuna karşı oyna.", social: "Sayfanı seç, arkadaşlarını çağır, oyuna gir." };
    document.title = copy.title;
    document.querySelector('meta[name="description"]')?.setAttribute("content", copy.description);
    document.querySelector('meta[property="og:title"]')?.setAttribute("content", copy.title);
    document.querySelector('meta[property="og:description"]')?.setAttribute("content", copy.social);
  }
  if (typeof window !== "undefined") window.dispatchEvent(new Event("urlcade:localechange"));
}

export const tr: Record<MessageKey, string> = new Proxy({} as Record<MessageKey, string>, {
  get(_target, property: string | symbol): string | undefined {
    if (typeof property !== "string") return undefined;
    const key = property as MessageKey;
    if (!(key in trTR)) return undefined;
    return getLocale() === "en-US" ? enUS[key] ?? trTR[key] : trTR[key];
  },
});
